<template>
    <v-field :has-error="hasError" :error-label="errorLabel" :helper="helper" >
        <q-chips-input v-model="inputValue"
                 :name="path"
                 :float-label="processedLabel"
                 :clearable="clearable"
                 :color="color"
                 :disable="form.busy || disable"
                 :hide-underline="hideUnderline"
                 :prefix="prefix"
                 :before="before"
                 :after="after"
                 :type="type"
                 @input="onInput"
                 @blur="event => $emit('blur', event)"></q-chips-input>
    </v-field>
  </template>
  
  <script>
  import mixins from './mixins'
  import {QChipsInput} from 'quasar-framework'

  export default {
    name: 'VChip',

    mixins,

    props: {
            type: {
                type: Array,
                default(){
                    return []
                }
            },
            autofocus: Boolean,
            prefix: String,
            color: String
        },

    data() {
      return {
        inputValue: this.value || [],
        focus: false,
      }
    },

    watch:{
            inputValue(){
                if(this.inputValue !== null || this.inputValue !== []){
                    this.focus = true
                }
            }
        },

    components: {
        QChipsInput
    }
  }
  </script>


// WEBPACK FOOTER //
// resources/assets/js/components/form/VChip.vue